<h2>Media Listing</h2>
<div class="media-form col-md-8 pl0">
  <alert></alert>
  <form [formGroup]="mediaSearchForm"  (ngSubmit)="onSubmit()" novalidate>
    <div class="form-row">
      <div class="col">
        <input type="text" class="form-control form-control-sm" formControlName="mediaLabel" [ngClass]="{ 'is-invalid': submitted &amp;&amp; mediaSearchForm.controls.mediaLabel.errors }" placeholder="Enter media label">
        @if (submitted && mediaSearchForm.controls.mediaLabel.errors) {
          <div class="text-danger">
            @if (mediaSearchForm.controls.mediaLabel.errors.required) {
              <div>Media is required</div>
            }
          </div>
        }
      </div>
      <div class="col">
        <select class="form-control form-control-sm mediatype" formControlName="mediaTypeName" [ngClass]="{ 'is-invalid': submitted &amp;&amp; mediaSearchForm.controls.mediaTypeName.errors }">
          <option value="">Choose media type</option>
          @for (type of mediatypes; track type) {
            <option value="{{type.mediaTypeName}}">{{type.mediaTypeName}}</option>
          }
        </select>
        @if (submitted && mediaSearchForm.controls.mediaTypeName.errors) {
          <div class="text-danger">
            @if (mediaSearchForm.controls.mediaTypeName.errors.required) {
              <div>Media Type is required</div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row button-row">
      <div class="col">
        <button type="submit" class="btn btn-sm btn-primary">Search</button>
        <button type="reset" class="btn btn-sm btn-outline-secondary">Reset</button>
      </div>
    </div>
  </form>
</div>

@if (filterApplied) {
  <div class="table-responsive">
    <table class="table table-bordered table-striped table-sm table-hover" id="dataTable" width="100%" cellspacing="0">
      <thead>
        <tr>
          <th width="70%">Media Label</th>
          <th width="30%">Media Type</th>
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td colspan="2" class="loading text-center">
              <span class="" [innerHTML]="msg"></span>
            </td>
          </tr>
        }
        @for (media of mediaResult; track media; let i = $index) {
          <tr data-id="{{media.mediaId}}">
            <td>{{media.mediaLabel}}</td>
            <td>{{media.mediaTypeName}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
